<!-- ===== DASHBOARD SOPRA ===== -->
<div class="dashboard-grid">

  <div class="card top-left">
    <div class="label">Beneficiariə fruitori</div>
    <div class="big">{{topData.utenti_attivi}}</div>
  </div>

  <div class="card top-right">
    <div class="label">Interventi effettuati</div>
    <div class="big">{{topData.num_int_totale}}</div>
  </div>

  <div class="card center">
    <div class="label">Periodo</div>
    <div class="label">{{ topFilters.inizio | date:'dd/MM/yyyy'}} - oggi</div>
    <div class="label">Totale beneficiariə</div>
    <div class="big">{{topData.utenti}}</div>
  </div>

  <div class="card bottom-left">
    <div class="label">Beneficiariə indiretti</div>
    <div class="big">{{topData.utenti_creati_indiretti}}</div>
  </div>

  <div class="card bottom-right">
    <div class="label">Beni e servizi erogati</div>
    <div class="big">{{topData.num_beni}}</div>
  </div>

</div>

<!-- ===== FILTRI + SECONDO BLOCCO ===== -->
<div class="dashboard-wrapper">

  <div class="filters">
    <input type="date" [(ngModel)]="filters.inizio"/>
    <input type="date" [(ngModel)]="filters.fine" />
    <button (click)="loadBottomDashboard()">Cerca</button>
  </div>

  <div class="diagram">

    <div class="center-box">
      <div class="label">Periodo selezionato</div>
      <div class="label">
        {{ filters.inizio | date:'dd/MM/yyyy' }} - {{ filters.fine | date:'dd/MM/yyyy' }}
      </div>
      <div class="label">Totale beneficiari</div>
      <div class="big">{{ bottomData.utenti_attivi_all + (bottomData.utenti_creati - bottomData.utenti_attivi_create) }}</div>
    </div>

    <div class="box top-left">
      <div class="label">Beneficiari con interventi</div>
      <div class="big">{{ bottomData.utenti_attivi_all }}</div>
    </div>

    <div class="box mid-left">
      <div class="label">Di cui nuovi beneficiari</div>
      <div class="big">{{ bottomData.utenti_attivi_create }}</div>
    </div>

    <div class="box bottom-left">
      <div class="label">Beneficiari indiretti</div>
      <div class="big">{{ bottomData.utenti_creati_indiretti }}</div>
    </div>

    <div class="box top-right">
      <div class="label">Interventi effettuati</div>
      <div class="big">{{ bottomData.num_int }}</div>
    </div>

    <div class="box bottom-right">
      <div class="label">Beni e servizi erogati</div>
      <div class="big">{{ bottomData.num_beni }}</div>
    </div>

  </div>
</div>